"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createFormatEgressTagsMiddleware = function () {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var formatEgressTagsMiddleware = function () { return function (next) { return function (activity) {
        var patchedActivity = JSON.parse(JSON.stringify(activity));
        if (patchedActivity) {
            if (patchedActivity.channelData && patchedActivity.channelData.tags) {
                var tags = patchedActivity.channelData.tags;
                if (typeof tags === 'string') {
                    return next(activity);
                }
                else if (tags instanceof Array) {
                    patchedActivity.channelData.tags = tags.toString();
                }
                else if (typeof patchedActivity.channelData.tags === 'object') {
                    try {
                        patchedActivity.channelData.tags = JSON.stringify(tags);
                    }
                    catch (error) {
                        console.error(error);
                    }
                }
            }
        }
        return next(patchedActivity);
    }; }; };
    return formatEgressTagsMiddleware;
};
exports.default = createFormatEgressTagsMiddleware;
//# sourceMappingURL=createFormatEgressTagsMiddleware.js.map